<!-- 头部-->
<template>
    <div class="whiteBg" style="min-width: 1200px;">
        <template v-if="!isLoginBox">
            <el-row :class="['section','flex','navHeight',isShowMenu?'':'borderMin']">
                <el-col :span="10">
                    <div class="logo flex justify-content">
                        <img src="../../assets/images/logo.png" @click="indexJump" />
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="itemsRights">
                        <template v-if="isLogin">
                            <div class="loginBtn flex jcright" style="float:right">
                                <!-- 是否有头像 -->
                                <template v-if="imageUrl">
                                    <img :src="imageUrl" />
                                </template>
                                <template v-else>
                                    <img src="../../assets/images/Signin.png" style="width:28px;display: inline-block;" />
                                </template>
                                <el-menu :default-active="activeIndex" class="buy-menu" mode="horizontal">
                                    <el-submenu index="3">
                                        <template slot="title">{{curLoginName}}</template>
                                        <el-menu-item
                                            v-for="(item,index) in selectBoxData"
                                            :key="index"
                                            :index="item.index"
                                            class="minMenu"
                                            @click="navJumpClick(item.path)"
                                        >
                                            <span>{{item.title}}</span>
                                        </el-menu-item>
                                    </el-submenu>
                                </el-menu>
                            </div>
                        </template>
                        <template v-else>
                            <div class="loginBtn flex jcright" @click="jumpLogin" style="float:right">
                                <img src="../../assets/images/Signin.png" />
                                <span>登录</span>
                            </div>
                        </template>
                    </div>
                    <div class="itemsLefts">
                        <el-input
                            v-if="isShowSearch"
                            type="text"
                            placeholder="搜索感兴趣的课程"
                            v-model="search"
                            class="navSearch"
                            @keyup.enter.native="searchEnter($event)"
                            >
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="handerSearch" style="cursor: pointer;"></i>
                        </el-input>
                    </div>
                </el-col>
            </el-row>
            <!-- 导航栏 -->
            <template v-if="isShowMenu">
                <div :class="['bgColor',isIndex==true?'':'difColor']">
                    <div class="section navWrap" style="padding: 5px 0 20px;">
                        <span v-for="(item,index) in navList" :key="index" @click="menuClick(index,item)">
                            <i :class="{selected:index == isCurBg}">{{item.name}}</i>
                        </span>
                    </div> 
                </div>
            </template>
        </template>
        <!-- 登陆 -->
        <template v-else>
            <el-row class="section flex navHeight lgoinsSection" style="z-index: 1000;">
                <el-col :span="10">
                    <div class="logo flex justify-content">
                        <img src="../../assets/images/logo03.png" @click="indexJump" />
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="section navWrap logoTitWrap">
                        <span v-for="(item,index) in navList" :key="index" @click="menuClick(index,item)">
                            <i>{{item.categoryName}}</i>
                        </span>
                    </div>
                </el-col>
            </el-row>
        </template>
    </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  export default {
    name: '',
    props: {
        isIndex:{                   //是否是首页
            type:Boolean,
            default:false
        },
        isShowMenu:{                //是否显示导航栏
            type:Boolean,
            default:true
        },
        isLoginBox:{                //是否是登录
            type:Boolean,
            default:false
        },
        isShowSearch:{              //是否显示搜索条
            type:Boolean,
            default:true
        }
    },
    data() {
        return {
            isCurBg:0,
            activeIndex: '1',
            isLogin:true,           //是否登录 ,selected:true
            search:'',
            selected:null,
            navList:[],  
            selectBoxData:[         //登录之后的下拉导航
                {index:'',path:'/',title:'首页'},                                       //首页
                {index:'1',path:'/myCourses',title:'我的课程'},                         //我的课程
                {index:'2',path:'/myExam',title:'我的考试'},                            //我的考试
                {index:'3',path:'/profile',title:'个人中心'},                           //个人中心
                {index:'5',path:'/purchaseHistory',title:'订单列表'},                   //订单列表
                {index:'8',path:'/myInvoice',title:'我的发票'},                         //我的发票
                {index:'8',path:'/myExchange',title:'礼品兑换'},                        //我的礼品
                {index:'7',path:'/logOut',title:'退出登录'},
            ],
            names:'',               //姓名缩写
            curLoginName:'',        //当前登录人
            imageUrl:'',            //头像地址
        }
    },
    created(){
        //this.isCurBg = 0;
        this.handleRoute(this.$route);

        //人
        this.showName();

	},
    // computed: {
    //     ...mapState({
    //         imageUrl:state => state.imageUrls1,
    //     })
    //     // ...mapState(['imageUrls1'])
    // },
    mounted() {
        this.initData();
    },
    watch: {
        $route: 'handleRoute',
        isLogin() {
        }
    },
    methods: {

        /**
         * 路由操作处理
         */
        handleRoute (route) {
            this.isCurBg = localStorage.getItem('isCurBg');
            this.showName();
            this.$forceUpdate();
            // if(route.path == "/index" || route.path == "/"){
            //     localStorage.setItem('isCurBg', 0);
            // }
        },


        /**
         * 搜索
         */
        handerSearch(){
            let that = this;
            this.$router.push({
                name: 'search',
                params:{'keyword':that.search}
            });
		},
        

        /**
         * 回车搜索
         */
        searchEnter(e){
            let that = this;
            var keyCode = window.event? e.keyCode:e.which;
			if(keyCode == 13 && this.search){
                this.$router.push({
                    name: 'search',
                    params:{'keyword':that.search}
                });
			}
        },


        //人
        showName(){
            let token = localStorage.getItem("token");
            let userInfo = JSON.parse(localStorage.getItem("userInfo"));

            if( (token && token.length > 0) && (userInfo && Object.keys(userInfo).length > 0) ){
                this.isLogin = true;
                this.$store.commit('ISLOGIN',true);                 //state存值:是否登录

                if(userInfo){
                    this.curLoginName = userInfo.name;              //登录人
                    if(userInfo.headerImage){
                        this.imageUrl = this.$global.baseUrl+'/upload/header/'+userInfo.headerImage;    //头像
                    }
                }
            }else{
                this.isLogin = false;
                this.$store.commit('ISLOGIN',false);               //state存值:是否登录
                this.curLoginName = '';
            }
        },


        /**
         * 跳转到登陆
         */
        jumpLogin(){
           this.$router.push('/login');
        },


        /**
         * 加载导航栏
         */
        initData(){
            let _this = this;
            this.$ajax.get(this.$api.index.allChannel, {}).then((res) => {
                if(res.code === 200) {
                    let arr = res.data;
                    let obj = {name:'首页'};
                    arr.unshift(obj);
                    _this.navList = arr;
                } else {
                    _this.$message.fail(res.msg);
                }
            }).catch((error) => {
            });
        },


        /**
         * 点击跳转
         */
        menuClick(index,item){
            this.isCurBg = index; 
            localStorage.setItem('isCurBg', index);
            this.$forceUpdate();

            if(item.name == '首页'){
                this.$router.push({
                    path: '/index',
                    query:{'index':0}
                });
            }else{ 
                this.$router.push({
                    path: '/courseIndex',
                    query:{'channelId':item.id,'index':index}
                });
            }
        },


        /**
         * 点击登录之后的下拉导航
         */
        navJumpClick(path){
            if(path == '/logOut'){
                this.confirmLogout();
            }else{
                this.$router.push({
                    path:path
                })
            }
        },

        /**
         * 学员确定退出
         */
        confirmLogout() {
            this.$confirm('确定要退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.stuLogout();
            }).catch(() => {
                      
            });
        },
       
        /**
         * 学员退出登录
         */
        stuLogout() {

            //确定
            let _this = this;
            let _$studentId = JSON.parse(localStorage.getItem('userInfo')).id;
            this.$ajax.get(this.$api.login.webLogout + "?studentId=" + _$studentId, {})
            .then(ret => {
                if (ret.code != 200) {
                    this.$message({message: "退出登录失败，" + res.msg, type: 'error'});
                    return;
                }

                //清空登录信息
                localStorage.removeItem("token");                   //token
                localStorage.removeItem("userInfo");                //登录人信息
                
                _this.isCurBg = 0; 
                localStorage.setItem('isCurBg', 0);
                _this.$store.commit('ISLOGIN',false);               //state存值:是否登录

                //返回首页
                this.isLogin = false;
                this.$router.push({
                    path:'/index',
                    query:{'index': 0}
                });
            })
            .catch(err => {
                this.$message({message: "退出登录失败！", type: 'error'});
            });
        },

        /**
         * 跳转到购物车
         */
        shopJump(){
            this.$router.push({
                path: '/shoppingCart',
            });
        },


        /**
         * 跳转到首页
         */
        indexJump(){
            this.$router.push({
                path: '/index',
                query:{'index':0}
            });
        },

    }
  }
</script>
<style scoped>
    .logo > img{
        cursor: pointer;
    }
    .logo > span{
        font-size: 13px;
        color: #000;
        padding-right: 25px;
        box-sizing: border-box;
    }
    .loginBtn{
        height: 36px;
        line-height: 36px;
    }
    .loginBtn > img{
        cursor: pointer;
        width: 30px;
        display: inline-block;
        height: 30px;
        border-radius: 50%;
    }
    .loginBtn > span{
        cursor: pointer;
        color: #05131c;
        font-size: 13px;
        font-weight: bold;
        padding-left: 10px;
    }
    .navHeight{
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .navWrap > span{
        display: inline-block;
    }
    .navWrap i{
        color: #333;
        font-size: 14px;
        padding:8px 20px;
        display: inline-block;
        cursor: pointer;
    }
    .navWrap i.selected{
        color: #333;
        background-color: #4fa0ff3b;
        border-radius: 5px;
    }
    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .buy-menu.el-menu .el-submenu__title {
        color: #333;
    }
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
        border-bottom: none !important;
    }
    .buy-box{
        font-size: 24px;
        margin-right: 50px;
        color: #666;
    }
    .item{
        cursor: pointer;
    }
    .lyIcon-min{
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
    }
    .logo > span.logoTit{
        color: #f7fbff !important;
    }
    .logoTitWrap i{
        color: #fff !important;
    }
    .section.flex.navHeight.lgoinsSection{
        position: absolute;
        transform: translate(-50%,0);
        left: 50%;
    }
    .borderMin{
        border-bottom: 1px solid #f5f5f5;
    }
    .itemsLefts{
        width:50%;
        padding-right:20px;
        box-sizing: border-box;
        float:right;
    }
    .itemsRights{
        float:right
    }


</style>


// WEBPACK FOOTER //
// src/components/NavBar/index.vue